import { Link } from 'react-router-dom';
import { hotRankings } from '@/mocks/comics';
import { ComicCard } from './ComicCard';

export function RankingList() {
  return (
    <section className="max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-20">
      <div className="mb-10">
        <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-accent-100 text-accent-700 mb-4">
          本周热门
        </span>
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            韩国漫画
            <span className="text-accent-500"> 热门排行</span>
          </h2>
          <p className="text-sm text-foreground-500 max-w-md">
            基于全网阅读量、收藏数综合计算，实时更新的韩国漫画人气排行榜
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-8">
        <div className="lg:col-span-1">
          <ComicCard comic={hotRankings[0]} variant="dark" showDescription />
        </div>
        <div className="lg:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-6">
          {hotRankings.slice(1, 5).map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>

      <div className="text-center mt-10">
        <Link
          to="/category/romance"
          className="inline-flex items-center gap-2 px-8 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          浏览全部漫画
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}